export var valuesWorkflowTranslationAPIs = ["Amplexor"];
/*

*/ 
//# sourceMappingURL=WorkflowTranslationAPIs.js.map